define.alias("shared/utils/emoji-picker", "auth/utils/emoji-picker");